import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';

// Using the SF86 since it is a superset of all form sections. This could be improved on.
import {
  FLAT_SF85,
  FLAT_SF852013,
  FLAT_SF85P,
  FLAT_SF85PS,
  FLAT_SF86,
  FLAT_PVQ_A,
  FLAT_PVQ_A_B_C,
  FLAT_PVQ_A_B_D,
  FLAT_PVQ_A_B
} from 'config/formTypes';

import {
  SF85, SF85P, SF86, SF852013, SF85PS, PVQ_A, PVQ_A_B, PVQ_A_B_C, PVQ_A_B_D
} from 'constants/formTypes';

/**
 * Takes an array of breadcrumbs and formats it in to a pretty trail
 */
/* eslint react/no-array-index-key: 0 */
const trail = (crumbs) => crumbs.map((crumb, i, arr) => {
  if (arr.length === i + 1) {
    return (
      <span key={`crumb-${i}`} className="title-text">
        {crumb}
      </span>
    );
  }

  return (
    <span key={`crumb-${i}`} className="crumb" aria-label={crumb}>
      {crumb} &gt;{' '}
    </span>
  );
});

const getFlatForm = (formType) => {
  switch (formType) {
    case SF85:
      return FLAT_SF85;
    case SF852013:
      return FLAT_SF852013;
    case SF85P:
      return FLAT_SF85P;
    case SF85PS:
      return FLAT_SF85PS;
    case SF86:
      return FLAT_SF86;
    case PVQ_A:
      return FLAT_PVQ_A;
    case PVQ_A_B:
      return FLAT_PVQ_A_B;
    case PVQ_A_B_C:
      return FLAT_PVQ_A_B_C;
    case PVQ_A_B_D:
      return FLAT_PVQ_A_B_D;
    default:
      return FLAT_SF86;
  }
};

export var SectionTitle = function ({ location, formType }) {
  const FLAT_FORM = getFlatForm(formType);

  const formSection = FLAT_FORM.find((s) => s.fullPath === location.pathname);

  if (!formSection || !formSection.breadcrumbs) {
    return null;
  }

  const title = trail(formSection.breadcrumbs);
  return <h1 className="title">{title}</h1>;
};

SectionTitle.propTypes = {
  location: PropTypes.object.isRequired,
  formType: PropTypes.string.isRequired
};

export default withRouter(SectionTitle);
